import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f57bf92")

_pushScopeId("data-v-7f57bf92")
const _hoisted_1 = { class: "flex flex--width flex--v flex--valign-c flex--gap-20" }
const _hoisted_2 = { class: "sectors-grid" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectableButton = _resolveComponent("SelectableButton")
  const _component_HelpButton = _resolveComponent("HelpButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_SelectableButton, {
      title: _ctx.$trans('company.all'),
      selected: _ctx.selectedSectors.length < 1,
      class: "selectable-button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickDeselectAll()))
    }, null, 8, ["title", "selected"]),
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedSectors, (sector) => {
        return (_openBlock(), _createBlock(_component_SelectableButton, {
          key: sector.id,
          title: _ctx.$trans(`company.${sector.name}`),
          selected: _ctx.selectedSectors.includes(sector.id),
          class: "selectable-button",
          onClick: ($event: any) => (_ctx.clickSelectSector(sector.id))
        }, {
          absoluteContent: _withId(() => [
            _createVNode(_component_HelpButton, {
              title: `company.${sector.name}`
            }, null, 8, ["title"])
          ]),
          _: 2
        }, 1032, ["title", "selected", "onClick"]))
      }), 128))
    ])
  ]))
})